// src/prototype/components/hub/BandedCard.tsx
// A hub card with the shared SectionHeaderBand across its top. Same API as SectionCard
// (icon, title, accent) plus an optional right slot, so the hub tabs use one card header style.
// SectionCard itself is untouched: the Command Center and the older brief page still use it.
import React from 'react';
import { SectionHeaderBand } from './SectionHeaderBand';

export interface BandedCardProps {
  icon: React.ReactNode;
  title: string;
  /** Tinted body (#F5F7FA) instead of white, as SectionCard's `accent`. */
  accent?: boolean;
  subtitle?: React.ReactNode;
  /** Meta or actions for the band's right slot. */
  right?: React.ReactNode;
  /** Body padding class; defaults to p-6, matching SectionCard. */
  bodyClassName?: string;
  children: React.ReactNode;
}

export const BandedCard: React.FC<BandedCardProps> = ({
  icon, title, accent = false, subtitle, right, bodyClassName = 'p-6', children,
}) => (
  <div className="rounded-xl border border-[#e5e7eb] bg-white overflow-hidden">
    <SectionHeaderBand icon={icon} title={title} subtitle={subtitle} right={right} />
    <div className={`${bodyClassName} ${accent ? 'bg-[#F5F7FA]' : ''}`}>{children}</div>
  </div>
);

export default BandedCard;
